import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-normal transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary/50 text-primary-foreground  dark:bg-primary/50 group-data-[state=active]:bg-primary ",
        secondary: "border-transparent bg-secondary text-secondary-foreground ",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground ",

        /** This is grayish. Not very ivory. */
        muted:
          "border-transparent bg-wood-50 dark:bg-border text-muted-foreground",

        /** This is ivory */
        tag: "border-transparent bg-wood-50 dark:bg-border text-muted-foreground py-0",

        /**
         *
         * The badge that is displayed inside a tab.
         */
        "inside-tab":
          "border-transparent ml-2 bg-deep-brown dark:bg-white text-white dark:text-deep-brown flex group-data-[state=active]:opacity-100 opacity-50 rounded-full px-2",

        outline: "text-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div
      className={cn(
        "font-sans group/badge",
        badgeVariants({ variant }),
        className
      )}
      {...props}
    />
  )
}

export { Badge, badgeVariants }
